
import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: 'h-6 w-6',
};

const AdminIcon = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 56 56"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.68 34.4401C44.4967 32.4568 44.94 30.3335 44.94 28.0001C44.94 26.3201 44.6833 24.7101 44.24 23.2168C42.7233 23.5668 41.1367 23.7535 39.48 23.7535C32.34 23.7535 26.0167 20.2301 22.1667 14.7935C20.09 19.8335 16.1233 23.9401 11.13 26.1801C11.0367 26.7635 11.0367 27.3935 11.0367 28.0001C11.0367 32.4991 12.8239 36.8138 16.0051 39.995C19.1864 43.1763 23.501 44.9635 28 44.9635C30.45 44.9635 32.8067 44.4268 34.93 43.4701C36.26 46.0135 36.8667 47.2735 36.82 47.2735C32.9933 48.5568 30.03 49.1868 28 49.1868C22.3533 49.1868 16.9633 46.9701 12.9967 42.9801C10.57 40.5535 8.77334 37.5901 7.77 34.3701H4.66667V23.7535H7.21C9.17 14.0935 17.7333 6.81348 28 6.81348C33.6 6.81348 38.99 9.03014 42.98 13.0201C45.9433 15.9601 47.9267 19.7168 48.7433 23.7535H51.3333V34.2301V34.2768V34.3701H51.1933L42.8867 42.0001L30.52 40.6001V36.7035H41.79L43.68 34.4401ZM21.63 27.4635C22.33 27.4635 23.0067 27.7435 23.4967 28.2568C23.9867 28.7468 24.2667 29.4235 24.2667 30.1235C24.2667 30.8235 23.9867 31.5001 23.4967 31.9901C23.0067 32.4801 22.33 32.7601 21.63 32.7601C20.16 32.7601 18.97 31.5935 18.97 30.1235C18.97 28.6535 20.16 27.4635 21.63 27.4635ZM34.3467 27.4635C35.8167 27.4635 36.9833 28.6535 36.9833 30.1235C36.9833 31.5935 35.8167 32.7601 34.3467 32.7601C32.8767 32.7601 31.6867 31.5935 31.6867 30.1235C31.6867 29.418 31.9669 28.7414 32.4658 28.2426C32.9646 27.7437 33.6412 27.4635 34.3467 27.4635Z"
            fill="currentColor"
        />
    </svg>
);

AdminIcon.propTypes = propTypes;
AdminIcon.defaultProps = defaultProps;

export default React.memo(AdminIcon);
